module.exports = __webpack_public_path__ + "img/laposte-logo.94df3dbe.png";